/*
 * Copyright (C) 2025-2026 The Klangmotor Authors (see AUTHORS.MD)
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

package io.peekandpoke.klang.audio_fe.utils

val UrlWithProtocolRegex = Regex(
    pattern = "https?://(www\\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)",
    options = setOf(RegexOption.IGNORE_CASE),
)

/**
 * Checks if the string is a url with a protocol, e.g. https://...
 */
fun String.isUrlWithProtocol(): Boolean {
    return UrlWithProtocolRegex.matches(this)
}
